import styled from "styled-components";
export default function Canva() {
  return (
    <Wrapper className="Canva">
      <div className="iframeDiv">
        <iframe
          loading="lazy"
          src="https://www.canva.com/design/DAGZwW0vZBo/UE6wippeu6fjNqAD0vPJ6g/watch?embed=1&autoplay=1&mute=1&loop=0"
          allowFullScreen
          autoPlay
          height={420}
          width={400}
        ></iframe>
      </div>
      <div className="linkDiv">
        <a
          href="https://servicemgmt.bugstopguys.com/media/EPC%20Budget%20Friendly%20Pricing%20Options.png"
          target="_blank"
          rel="noopener"
        >
          Click here for new pricing options!
        </a>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex: 2;
  width: 100vw;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--main-bg-color);

  .iframeDiv {
    display: flex;
    flex: 1;
    padding-bottom: 10px;
  }
  .linkDiv {
    display: flex;
    flex: 1;
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 24px;
  }
`;
